import { memo } from "react";
import { StyleSheet } from "react-native-unistyles";
import { View } from "@src/components/View";
import { ActivityIndicator, ScrollView } from "react-native";
import { Stack } from "expo-router";
// @ts-expect-error baseline 2026-02-16
import { WebLayout } from "@src/components/web";
import { Button, Text } from "@src/components";
import { UserListTable, UserListFilterRow } from "@visioni/a3s-access/app";
import { useUsersAndPermissionsPage } from "@src/features/settings/hooks";

const UsersAndPermissionsScreen = memo(() => {
  const {
    permissionsLoading,
    permissionsError,
    isTenantAdmin,
    isReady,
    isError,
    filters,
    setFilters,
    filterSites,
    filterCameras,
    filteredUsers,
    handleInviteUser,
    handleEditUser,
  } = useUsersAndPermissionsPage();

  if (permissionsLoading || (!permissionsError && !isTenantAdmin)) {
    return (
      <>
        <Stack.Screen options={{ headerShown: false }} />
        <WebLayout>
          <View flex={1} alignItems="center" justifyContent="center">
            <ActivityIndicator />
          </View>
        </WebLayout>
      </>
    );
  }

  if (permissionsError) {
    return (
      <>
        <Stack.Screen options={{ headerShown: false }} />
        <WebLayout>
          <View flex={1} alignItems="center" justifyContent="center" p="4xl">
            <Text textStyle="md/medium" color="text">
              Unable to verify permissions. Please try again later.
            </Text>
          </View>
        </WebLayout>
      </>
    );
  }

  return (
    <>
      <Stack.Screen options={{ headerShown: false }} />
      <WebLayout>
        <ScrollView style={styles.scrollView} contentContainerStyle={styles.contentContainerStyle}>
          <View flexDirection="row" alignItems="center" justifyContent="space-between" mb="3xl">
            <Text textStyle="lg/semibold" color="text">
              Users
            </Text>
            <Button label="Invite User" variant="primary" size="sm" onPress={handleInviteUser} />
          </View>
          <View mb="3xl" style={styles.filterRowWrapper}>
            <UserListFilterRow
              filters={filters}
              onFiltersChange={setFilters}
              sites={filterSites}
              cameras={filterCameras}
            />
          </View>
          {isError ?
            <Text textStyle="sm/regular" color="textMuted" style={styles.errorMessage}>
              Something went wrong. Please try again.
            </Text>
          : !isReady ?
            <ActivityIndicator style={styles.loader} />
          : <UserListTable users={filteredUsers} onEditUser={handleEditUser} />}
        </ScrollView>
      </WebLayout>
    </>
  );
});

export default UsersAndPermissionsScreen;

const styles = StyleSheet.create((theme) => ({
  scrollView: {
    flex: 1,
  },
  contentContainerStyle: {
    flexGrow: 1,
    padding: theme.spacing["3xl"],
  },
  filterRowWrapper: {
    zIndex: 1,
  },
  loader: {
    paddingVertical: theme.spacing["9xl"],
  },
  errorMessage: {
    paddingVertical: theme.spacing["9xl"],
    textAlign: "center",
  },
}));
